export type ApplicationErrorVerbosityLevel = 'flash-message' | 'no-flash-message' | 'no-log';

export const ApplicationErrors = {
    default: 'flash-message',
    'flash-message': 'flash-message',
    'cart-not-found': 'flash-message',
    'cart-unavailable': 'flash-message',
    'max-allowed-limit': 'flash-message',
    'packetery-address-id-invalid': 'flash-message',
    'invalid-credentials': 'flash-message',
    'invalid-refresh-token': 'flash-message',
    'invalid-token': 'no-log',
    'loyalty-club-points-overdraft': 'flash-message',
    'order-emails-not-sent': 'flash-message',
    'order-empty-cart': 'flash-message',
    'personal-data-request-type-invalid': 'flash-message',
    'blog-category-not-found': 'flash-message',
    'image-type-invalid': 'flash-message',
    'order-not-found': 'flash-message',
    'unknown-claim-create': 'flash-message',
    'unknown-return-create': 'flash-message',
    'personal-data-hash-invalid': 'flash-message',
    'product-price-missing': 'flash-message',
    'promo-code-already-applied': 'flash-message',
    'promo-code-at-most-one-percentage': 'flash-message',
    'promo-code-discount-coupon-already-applied': 'flash-message',
    'reservations-disabled-at-place': 'flash-message',
    'no-result-found-for-slug': 'flash-message',
    'store-not-found': 'flash-message',
    'loyalty-club-points-unverified': 'flash-message',
    'loyalty-club-points-changed': 'flash-message',
    'gift-voucher-not-applicable-for-personal-pickup': 'flash-message',
    'promo-code-does-not-meet-minimum-order-price': 'flash-message',
    GIFT_CODE_CANNOT_BE_APPLIED_ON_CART_ITEMS: 'flash-message',
    'order-stock-availability-error': 'flash-message',
    'loyalty-club-points-used-for-voucher': 'flash-message',
    'promo-code-available-for-registered-customer-user-only': 'flash-message',
    'promo-code-not-usable-on-vouchers': 'flash-message',
    'wishlist-not-found': 'flash-message',
    'wishlist-item-already-exists': 'flash-message',
    'wishlist-item-not-found': 'flash-message',
    'invalid-account': 'flash-message',
    'inactive-account': 'flash-message',
    'not-confirmed-account': 'flash-message',
    'invalid-reset-password-hash': 'flash-message',
    'already-confirmed-account': 'flash-message',
    'unable-to-generate-breadcrumb-items': 'no-flash-message',
    'seo-page-not-found': 'no-flash-message',
    'blog-article-access-denied': 'no-flash-message',
    'not-all-required-gdpr-consents-checked': 'flash-message',
    'customer-default-and-selected-delivery-address-mismatch': 'flash-message',
    'too-many-requests': 'flash-message',
} as const;

type KeysMatching<T, V extends ApplicationErrorVerbosityLevel> = {
    [K in keyof T]: T[K] extends V ? K : never;
}[keyof T];

export type FlashMessageKeys = KeysMatching<typeof ApplicationErrors, 'flash-message'>;

export type NoFlashMessageKeys = KeysMatching<typeof ApplicationErrors, 'no-flash-message'>;

export type NoLogKeys = KeysMatching<typeof ApplicationErrors, 'no-log'>;

export type ApplicationErrorsType = keyof typeof ApplicationErrors;

export const isFlashMessageError = (errorCode: string): errorCode is FlashMessageKeys =>
    Object.keys(ApplicationErrors).includes(errorCode) &&
    ApplicationErrors[errorCode as keyof typeof ApplicationErrors] === 'flash-message';

export const isNoFlashMessageError = (errorCode: string): errorCode is NoFlashMessageKeys =>
    Object.keys(ApplicationErrors).includes(errorCode) &&
    ApplicationErrors[errorCode as keyof typeof ApplicationErrors] === 'no-flash-message';

export const isNoLogError = (errorCode: string): errorCode is NoLogKeys =>
    Object.keys(ApplicationErrors).includes(errorCode) &&
    ApplicationErrors[errorCode as keyof typeof ApplicationErrors] === 'no-log';
